function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3378 19.7855C18.9153 19.7855 19.3834 19.3174 19.3834 18.7399C19.3834 18.1625 18.9153 17.6943 18.3378 17.6943C17.7603 17.6943 17.2922 18.1625 17.2922 18.7399C17.2922 19.3174 17.7603 19.7855 18.3378 19.7855Z",
  fill: "url(#paint11_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.0744 26.2201C14.6519 26.2201 15.12 25.7519 15.12 25.1745C15.12 24.597 14.6519 24.1289 14.0744 24.1289C13.497 24.1289 13.0289 24.597 13.0289 25.1745C13.0289 25.7519 13.497 26.2201 14.0744 26.2201Z",
  fill: "url(#paint12_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.247 23.1634C16.8244 23.1634 17.2925 22.6953 17.2925 22.1178C17.2925 21.5404 16.8244 21.0723 16.247 21.0723C15.6695 21.0723 15.2014 21.5404 15.2014 22.1178C15.2014 22.6953 15.6695 23.1634 16.247 23.1634Z",
  fill: "url(#paint13_linear)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1803 5.06738C7.80224 5.06738 5.06765 7.80197 5.06765 11.18C5.06765 14.558 7.80224 17.2926 11.1803 17.2926C14.5583 17.2926 17.2929 14.558 17.2929 11.18C17.2929 7.80197 14.5583 5.06738 11.1803 5.06738ZM15.2017 11.18C15.2017 13.432 13.3518 15.2014 11.1803 15.2014C9.00867 15.2014 7.15881 13.3516 7.15881 11.18C7.15881 9.0084 9.00867 7.15854 11.1803 7.15854C13.3518 7.15854 15.2017 8.92797 15.2017 11.18Z",
  fill: "url(#paint14_linear)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1796 0C4.9866 0 0 4.9866 0 11.1796C0 13.1903 0.884719 15.2815 0.965148 15.5228C1.28686 16.2466 1.84987 17.2922 2.25201 17.9357L9.65147 29.1153C10.0536 29.6783 10.6166 30 11.1796 30C11.7426 30 12.3861 29.6783 12.7078 29.1153L14.9598 25.6568L13.1903 24.5308L11.0992 27.748L3.86059 16.8097C3.53887 16.2466 2.97587 15.3619 2.73458 14.7185C2.65416 14.5576 1.9303 12.7882 1.9303 11.1796C1.9303 6.19303 6.03217 2.09115 11.0188 2.09115C16.0054 2.09115 20.1072 6.19303 20.1072 11.1796C20.1072 12.7882 19.3834 14.5576 19.3029 14.6381C19.0617 15.2011 18.5791 16.1662 18.1769 16.7292L17.1314 18.3378L18.9008 19.4638L19.9464 17.8552C20.3485 17.2118 20.9115 16.1662 21.2332 15.4424C21.2332 15.3619 22.1984 13.1903 22.1984 11.0992C22.3593 4.9866 17.3727 0 11.1796 0Z",
  fill: "url(#paint15_linear)"
});

var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 18.3378,
  y1: 17.6943,
  x2: 18.3378,
  y2: 19.7855,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 14.0744,
  y1: 24.1289,
  x2: 14.0744,
  y2: 26.2201,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 16.247,
  y1: 21.0723,
  x2: 16.247,
  y2: 23.1634,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 11.1803,
  y1: 5.06738,
  x2: 11.1803,
  y2: 17.2926,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 11.1011,
  y1: 0,
  x2: 11.1011,
  y2: 30,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.390625,
  stopColor: "#00AAE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#009EE0",
  stopOpacity: 0.32
})));

function SvgLocationNav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 60,
    viewBox: "0 0 25 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationNav);
export default __webpack_public_path__ + "static/media/locationNav.9667d9ad.svg";
export { ForwardRef as ReactComponent };